// lib
import React from 'react'
import PropTypes from 'prop-types'

// components
import Popup from '@aytm/lib/rfd-ui/components/basic/popup'

// styles
import style from '@aytm/app/survey/editor/styles/content/PopupHelper.module.scss'

// <Component>
PopupHelper.propTypes = {
  width: PropTypes.string,
  trigger: PropTypes.string,
  children: PropTypes.func.isRequired,
  direction: PropTypes.string,
  popupOffset: PropTypes.number
}
export default function PopupHelper(props) {
  const { width = '350px', direction = 'topright', trigger = 'click', children, popupOffset = 13, ...restProps } = props
  return (
    <Popup
      width={width}
      trigger={trigger}
      content={children}
      direction={direction}
      className={style.component}
      popupOffset={popupOffset}
      headerCloseButton={true}
      {...restProps}
    >
      <i className="icon-aytmfd-help" />
    </Popup>
  )
}
